import Vue from "vue";
import VueRouter from "vue-router";

import Home from "@/views/Home";
import SuiteRentals from "@/views/SuiteRentals";
import SeasonalSuites from "@/views/SeasonalSuites";
import WaysToUse from "@/views/WaysToUse";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/suite-rentals",
    name: "SuiteRentals",
    component: SuiteRentals,
  },
  {
    path: "/season-suites",
    name: "SeasonSuites",
    component: SeasonalSuites,
  },
  {
    path: "/ways-to-use",
    name: "WaysToUse",
    component: WaysToUse,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "is-active",
  base: "suites",
});

export default router;
